import {connect} from '@modifi/redux'
import {aReplace} from '@modifi/router'
import DummyRedirectPage from './DummyRedirectPage'

const mapStateToProps = (): any => ({})

const mapDispatchToProps = {
  redirect: aReplace,
}

export default connect(mapStateToProps, mapDispatchToProps)(DummyRedirectPage)
